var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.512,
    height: 20.3,
    viewBox: "0 0 22.512 20.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.512,
    height: 20.3,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.6,176.68h14.06v-.338q0-4.487,0-8.974a2.978,2.978,0,0,1,.009-.328.741.741,0,0,1,.725-.677.761.761,0,0,1,.789.639,2.035,2.035,0,0,1,.016.328q0,4.967,0,9.935c0,.7-.271.972-.983.972H54.028c-.694,0-.965-.27-.965-.963q0-5.005,0-10.011c0-.565.313-.913.8-.9a.748.748,0,0,1,.733.671,2.954,2.954,0,0,1,.009.328q0,4.487,0,8.974v.345",
    transform: "translate(-50.375 -157.936)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.512,7.816a.767.767,0,0,1-.943.815,1.489,1.489,0,0,1-.426-.21Q16.316,5.14,11.5,1.848a.354.354,0,0,0-.48,0Q6.2,5.143,1.372,8.422a1.818,1.818,0,0,1-.329.185.753.753,0,0,1-.915-.279.764.764,0,0,1,.086-.956,2.085,2.085,0,0,1,.317-.249Q5.576,3.692,10.623.263a.89.89,0,0,1,1.263,0q5.088,3.458,10.176,6.916a.879.879,0,0,1,.45.64",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.8,4.063c-.618,0-1.2.011-1.775-.006a1.255,1.255,0,0,1-.551-.135.706.706,0,0,1-.331-.826.718.718,0,0,1,.692-.562c.926-.011,1.852-.013,2.777,0a.717.717,0,0,1,.716.712c.019.69.02,1.381,0,2.07a.755.755,0,0,1-.774.714.766.766,0,0,1-.749-.74c-.011-.2,0-.4,0-.606s0-.386,0-.622",
    transform: "translate(-292.51 -2.398)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHome);
export default __webpack_public_path__ + "static/media/icon_home.aba9de6e2a0824942ac5c974ac71539d.svg";
export { ForwardRef as ReactComponent };